import type { ILanguageResources, ITranslationModule } from '../../../../../interfaces';
import { interpolate } from '../../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.views.v6.FranchiseeV6QuoteView.';

  public static readonly reportGenerationDraftDialog = `${Id.prefix}reportGenerationDraftDialog`;
  public static readonly generateDraftReport = `${Id.prefix}generateDraftReport`;
  public static readonly emailedLinkToDocument = `${Id.prefix}emailedLinkToDocument`;
}

export class LangFranchiseeV6QuoteView {
  private constructor() {}

  public static reportGenerationDraftDialog(): string {
    return interpolate(Id.reportGenerationDraftDialog);
  }
  public static generateDraftReport(): string {
    return interpolate(Id.generateDraftReport);
  }
  public static emailedLinkToDocument(): string {
    return interpolate(Id.emailedLinkToDocument);
  }
}

export class FranchiseeV6QuoteViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.reportGenerationDraftDialog,
      'A Draft report is intended for internal use only. Only an **Issued** version of the quote should be signed by a customer as this version can only be generated when all configurations and pricing is valid.\n\nPurchase Orders can only be generated and submitted to your manufacturer from an Issued/Approved Quote.\n\nDo you wish to proceed with generating the draft report?',
      'Dialog text for confirming draft report generation'
    );
    register.add(Id.generateDraftReport, 'Generate Draft Report', 'Button label for generating a draft report');
    register.add(
      Id.emailedLinkToDocument,
      'You will be emailed a link to the document when it is ready',
      'Toast message after report generation'
    );
  }
}
